<template>
    <div>
        <v-dialog
            persistent
            v-model="display"
            width=500>
            <v-card>
                <v-card-title>{{ $t("delete_title") }}</v-card-title>
                <v-card-subtitle v-if="deletable">{{ $t("delete_subtitle") }}</v-card-subtitle>
                <v-card-text>
                    <v-list v-for="item in items" :key="item.id" dense>
                        <v-list-item>
                            <v-list-item-title>
                                {{ item[name] }}
                            </v-list-item-title>
                            <v-list-item-icon>
                                <v-icon :color="item.meta.deletable ? 'success' : 'error'">{{item.meta.deletable ? 'mdi-check-circle' : 'mdi-alert-circle'}}</v-icon>
                            </v-list-item-icon>
                        </v-list-item>
                        <v-divider v-if="items.length > 1"></v-divider>
                    </v-list>
                    <v-alert type="error" class="mt-4" v-if="!deletable">
                         <div v-if="items.length > 1">
                            Records marked with the red warnning cannot be deleted from the system!
                        </div>
                        <div v-else>
                            This record cannot be deleted!
                        </div>
                    </v-alert>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        text
                        color="error"
                        :disabled="!deletable || loading.submit"
                        :loading="loading.submit"
                        @click="submit">
                        {{ $t("delete_btn") }}
                    </v-btn>
                    <v-btn text @click="close">
                        {{ $t("cancel_btn") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: "DeleteDialog",
    components: {

    },
    data() {
        return {
            display: false,
            name: null,
            deletable: false,
            items: [],
            target: null,
            loading: {
                submit: false
            }
        }
    },
    computed: {
        
    },
    methods: {
        open(params) {
            this.items = params.items;
            this.name = params.name ? params.name : "name";
            this.target = params.target;
            this.setDeletable();
            this.display = true;
        },
        close() {
            this.display = false;
            this.items = [];
            this.loading.submit = false;
            this.target = null;
        },
        setDeletable() {
            let result = true;
            this.items.forEach(each => {
                if(each.meta.deletable === false) result = false;
            });
            this.deletable = result;
        },
        submit() {
            this.loading.submit = true;
            let itemsIds = [];
            this.items.forEach(each => itemsIds.push(each.id));
            this.$emit("submit", {itemsIds, target: this.target});
        }
        
    }
}
</script>